module.exports = __webpack_public_path__ + "static/ahefu-059be3fd879ec17ea7f0a326368cb93e.jpg";